import React, { FC } from "react";
import { NoDataRow } from "./NoDataRow/NoDataRow";
import { Subtitle } from "../Subtitle/Subtitle";
import { TableWrapper, TableHead, TableBodyWrapper } from "../Table";
import styles from "./FieldTable.module.scss";

export interface IFieldTable {
  className?: string;
  subtitle?: string;
  columns: string[];
  row: React.ReactNode;
  data: unknown[];
  otherRow?: React.ReactNode;
  children?: React.ReactNode;
  width?: string;
  name?: string;
}

export const FieldTable: FC<IFieldTable> = ({
  className,
  subtitle,
  columns,
  data,
  row: Row,
  children,
  otherRow,
  width = "100%",
  name,
}) => {
  return (
    <div
      className={`${styles.wrapper} ${className}`}
      style={{ width: `${width}` }}
    >
      {subtitle && <Subtitle text={subtitle} />}
      <TableWrapper>
        <TableHead columns={columns} className={styles.tableHead} />
        <TableBodyWrapper className={styles.tableBody}>
          {!data?.length ? (
            <NoDataRow colLength={columns?.length} />
          ) : (
            data?.map((item, idx) => (
              <Row key={item.id || item.key} idx={idx} name={name} />
            ))
          )}
          {otherRow}
        </TableBodyWrapper>
      </TableWrapper>
      {children}
    </div>
  );
};
